import React from "react";
import "./App.css";
import Header from "./Header";
import Homepage from "./Homepage";

const App = () => {
  return (
    <>
      <Header />
      <Homepage />
    </>
  );
};

export default App;
